<template>
    <svg viewBox="0 0 19 20" xmlns="http://www.w3.org/2000/svg" class="icon-svg icon-search">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.70788 0.650208C4.06458 0.650208 0.300415 4.41438 0.300415 9.05767C0.300415 13.701 4.06458 17.4651 8.70788 17.4651C10.6679 17.4651 12.4714 16.7943 13.9012 15.6699L17.4786 19.2473C17.5442 19.3129 17.6332 19.3498 17.7261 19.3498C17.8189 19.3498 17.9079 19.3129 17.9736 19.2473L18.8975 18.3233C18.9631 18.2577 19 18.1687 19 18.0759C19 17.983 18.9631 17.894 18.8975 17.8284L15.3201 14.251C16.4445 12.8212 17.1153 11.0177 17.1153 9.05767C17.1153 4.41438 13.3512 0.650208 8.70788 0.650208ZM2.30703 9.05767C2.30703 5.5226 5.17281 2.65682 8.70788 2.65682C12.243 2.65682 15.1087 5.5226 15.1087 9.05767C15.1087 12.5927 12.243 15.4585 8.70788 15.4585C5.17281 15.4585 2.30703 12.5927 2.30703 9.05767Z"
        />
    </svg>
</template>

<script>
export default {
    props: {},
    components: {},
    data: () => {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped>
.icon-search{
    width: 18px;
}
</style>
